/**
 * weglot-variant-image-de.js — v4
 * ─────────────────────────────────────────────────────────────────────────────
 * 1. Page produit  : swap carousel + GLightbox selon langue Weglot
 * 2. Cartes produit: switch js-img-fr / js-img-de selon langue Weglot
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════════════════
     UTILITAIRES COMMUNS
  ═══════════════════════════════════════════════════════════════════════════ */

  function onWeglotReady(cb) {
    if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
      cb();
    } else if (window.Weglot) {
      Weglot.on('initialized', cb);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        if (window.Weglot && typeof Weglot.getCurrentLang === 'function') cb();
        else if (window.Weglot) Weglot.on('initialized', cb);
        else console.warn('[weglot-img-de] Weglot introuvable.');
      });
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     1. CARTES PRODUIT
     Logique : chaque carte a déjà deux <img> rendus par Liquid :
       .js-img-fr  → image FR (visible par défaut)
       .js-img-de  → image DE (display:none par défaut)
     On switche leur display selon la langue.
  ═══════════════════════════════════════════════════════════════════════════ */

  function applyCardImages(lang) {
    var isDE = lang === 'de';

    document.querySelectorAll('.sekoya-product-card').forEach(function (card) {
      var imgFr = card.querySelector('.js-img-fr');
      var imgDe = card.querySelector('.js-img-de');

      if (!imgFr) return; // carte sans image, on passe

      if (isDE && imgDe) {
        // Passer en DE
        imgFr.style.display = 'none';
        imgDe.style.display = '';
      } else {
        // Revenir en FR (ou si pas d'image DE disponible)
        imgFr.style.display = '';
        if (imgDe) imgDe.style.display = 'none';
      }
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     2. PAGE PRODUIT — CAROUSEL
  ═══════════════════════════════════════════════════════════════════════════ */

  function getVariantDeData() {
    try {
      var el = document.getElementById('variant-images-de');
      if (!el) return {};
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      console.warn('[weglot-img-de] JSON parse error:', e);
      return {};
    }
  }

  function swapOne(img, newSrc, newLightbox) {
    if (!img || !newSrc) return;
    if (!img.dataset.originalSrc)      img.dataset.originalSrc      = img.src;
    if (!img.dataset.originalLightbox) img.dataset.originalLightbox = img.dataset.lightboxSrc || '';
    img.src = newSrc;
    if (newLightbox) img.dataset.lightboxSrc = newLightbox;
  }

  function restoreOne(img) {
    if (!img) return;
    if (img.dataset.originalSrc)      img.src                = img.dataset.originalSrc;
    if (img.dataset.originalLightbox) img.dataset.lightboxSrc = img.dataset.originalLightbox;
  }

  function applyAllSlides(lang, variantDeData) {
    document.querySelectorAll('#slideProductrProduct img[data-variant-id]').forEach(function (img) {
      var vid  = img.dataset.variantId;
      var data = variantDeData[vid];
      if (lang === 'de' && data && data.img) {
        swapOne(img, data.img, data.lightbox);
      } else {
        restoreOne(img);
      }
    });

    // Image principale sans data-variant-id
    var mainImg = document.getElementById('product-image');
    if (mainImg && !mainImg.dataset.variantId) {
      if (lang === 'de' && mainImg.dataset.srcDe) {
        swapOne(mainImg, mainImg.dataset.srcDe, mainImg.dataset.lightboxDe);
      } else {
        restoreOne(mainImg);
      }
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     3. PAGE PRODUIT — GLIGHTBOX (zoom)
  ═══════════════════════════════════════════════════════════════════════════ */

  function patchZoomTriggers(variantDeData) {
    document.querySelectorAll('.zoomImage').forEach(function (wrapper) {
      var img  = wrapper.querySelector('img');
      if (!img) return;
      var vid  = img.dataset.variantId;
      var data = vid ? variantDeData[vid] : null;
      var lang = window.Weglot ? Weglot.getCurrentLang() : 'fr';
      if (lang === 'de' && data && data.lightbox) {
        wrapper.dataset.lightboxSrc = data.lightbox;
      } else {
        var orig = img.dataset.originalLightbox;
        if (orig) wrapper.dataset.lightboxSrc = orig;
      }
    });
  }

  function swapLightboxImages(variantDeData) {
    var lang = window.Weglot ? Weglot.getCurrentLang() : 'fr';
    if (lang !== 'de') return;

    var carouselImgs = document.querySelectorAll('#slideProductrProduct img[data-variant-id]');
    var normalize    = function (url) { return url.replace(/^https?:/, ''); };

    document.querySelectorAll('#glightbox-slider .gslide-image img').forEach(function (lbImg) {
      carouselImgs.forEach(function (carouselImg) {
        var carouselLbSrc = carouselImg.dataset.lightboxSrc || '';
        if (normalize(lbImg.src) === normalize(carouselLbSrc)) return;
        var originalLb = carouselImg.dataset.originalLightbox || '';
        if (originalLb && normalize(lbImg.src) === normalize(originalLb) && carouselLbSrc) {
          lbImg.src = carouselLbSrc;
        }
      });

      // Image principale
      var mainImg = document.getElementById('product-image');
      if (mainImg) {
        var mainOrigLb = mainImg.dataset.originalLightbox || '';
        var mainCurrLb = mainImg.dataset.lightboxSrc || '';
        if (mainOrigLb && normalize(lbImg.src) === normalize(mainOrigLb) && mainCurrLb) {
          lbImg.src = mainCurrLb;
        }
      }
    });
  }

  function initLightboxObserver(variantDeData) {
    function observeLightbox() {
      var container = document.querySelector('.gcontainer');
      if (!container) {
        var bodyObserver = new MutationObserver(function (mutations, obs) {
          var c = document.querySelector('.gcontainer');
          if (c) { obs.disconnect(); watchSlider(c, variantDeData); }
        });
        bodyObserver.observe(document.body, { childList: true, subtree: false });
      } else {
        watchSlider(container, variantDeData);
      }
    }

    function watchSlider(container, variantDeData) {
      var sliderObserver = new MutationObserver(function () {
        swapLightboxImages(variantDeData);
      });
      sliderObserver.observe(container, { childList: true, subtree: true });
      swapLightboxImages(variantDeData);
    }

    observeLightbox();
  }

  /* ═══════════════════════════════════════════════════════════════════════════
     BOOTSTRAP
  ═══════════════════════════════════════════════════════════════════════════ */

  onWeglotReady(function () {
    var lang = Weglot.getCurrentLang();

    // ── Cartes produit ──────────────────────────────────────────────────────
    applyCardImages(lang);

    // ── Page produit ────────────────────────────────────────────────────────
    var variantDeData = getVariantDeData();
    applyAllSlides(lang, variantDeData);
    patchZoomTriggers(variantDeData);
    initLightboxObserver(variantDeData);

    // ── Changement de langue ────────────────────────────────────────────────
    Weglot.on('languageChanged', function (newLang) {
      applyCardImages(newLang);
      applyAllSlides(newLang, variantDeData);
      patchZoomTriggers(variantDeData);
    });
  });

})();